import React from 'react';
import { MultiCombo } from 'fw/forms';

class BusinessCertificationMultiCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        let items = [];

        items.push({ label: "NMSDC", value: "NMSDC"});
        items.push({ label: "WBENC", value: "WBENC"});
        items.push({ label: "NGLCC", value: "NGLCC"});
        items.push({ label: "Other", value: "OTHER"});

        this.setState({items});
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <MultiCombo 
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Select..."}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default BusinessCertificationMultiCombo;

// Mark this as a form component
BusinessCertificationMultiCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/businessCertificationMultiCombo/BusinessCertificationMultiCombo.js